import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PassportInformationComponent } from './passport-information.component';
import { DateFormatModule, StaticMsgModule } from '@lib/pipes';
import { PassportNameModule } from '../../pipes/passport-name/passport-name.module';

@NgModule({
  declarations: [PassportInformationComponent],
  imports: [CommonModule, StaticMsgModule, DateFormatModule, PassportNameModule],
  exports: [PassportInformationComponent],
})
export class PassportInformationModule {}
